import { Mui } from "@osu/react-ui";
import { mergeSxStyles } from "../../../../../util/functions";
import Chips from "./Chips";
import DescriptionDetails from "./Details";
import DescriptionTerm from "./Term";

const styles = {
  mt: 0,
  pl: 2,
};

function DescriptionList({ year, period, baseId, sx, ...rest }) {
  return (
    <Mui.Box component="dl" sx={mergeSxStyles(sx, styles)}>
      <DescriptionTerm year={year} period={period} {...rest} />
      <Mui.Box component="dd" sx={{ mx: 0, my: 1 }}>
        <Chips year={year} period={period} {...rest} />
      </Mui.Box>
      <DescriptionDetails baseId={baseId} year={year} period={period} {...rest} />
    </Mui.Box>
  );
}

export default DescriptionList;
